import { Avatar as ChakraAvatar, type AvatarRootProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends AvatarRootProps {
  name?: string
  src?: string
}

export default forwardRef<HTMLDivElement, Props>(({ name, src, ...rest }, ref) => {
  return (
    <ChakraAvatar.Root aspectRatio={1} colorPalette={pickPalette(name)} ref={ref} {...rest}>
      <ChakraAvatar.Fallback name={name} />
      <ChakraAvatar.Image src={src} />
    </ChakraAvatar.Root>
  )
})

function pickPalette(name?: string) {
  const index = name ? name.charCodeAt(0) % colorPalette.length : 0
  return colorPalette[index]
}

const colorPalette = ['red', 'blue', 'green', 'yellow', 'purple', 'orange']
